import { gql } from "@apollo/client";

export const UPDATE_CUIDADOS_DOMICILIARIOS = gql`
    mutation UpdateCuidadosDomiciliarios(
        $screen: Int!
        $input: AddCuidadosDomiciliariosInput!)
    {
        createAndUpdateCuidadosDomiciliarios(
            screen: $screen
            input: $input
        ){
            idCuidadosDomiciliariosRI
        }
    }
`;